
















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { formatMoney, objectify } from "@/helpers";
import PerformanceWeeklyGraph from "./PerformanceWeeklyGraph.vue";

@Component({
  components: {
    PerformanceWeeklyGraph
  }
})
export default class PerformanceWeekCard extends Vue {
  @Prop({ default: {} }) dashboardStats!: any;

  weeklyGraphData: any[] = [];

  @Watch("dashboardStats")
  onCallModeChange(data: any) {
    this.weeklyGraphData = objectify(data).weekly_graph.reverse();
  }

  get commissionsWeek() {
    return formatMoney(objectify(this.dashboardStats).commissions_week);
  }

  get totalSalesPremiumWeek() {
    return formatMoney(objectify(this.dashboardStats).sales_premium_week);
  }

  get salesVolumeWeek() {
    return objectify(this.dashboardStats).sales_volume_week
      ? objectify(this.dashboardStats).sales_volume_week
      : 0;
  }
}
